import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { countryService } from '../services/countryService';
import CountrySelectionPage from './CountrySelectionPage';

const CountryGate = ({ children }) => {
  const [hasCountry, setHasCountry] = useState(null);
  const [checking, setChecking] = useState(true);
  const { isLoggedIn, loading: authLoading } = useAuth();

  useEffect(() => {
    checkCountry();
    
    // Listen for storage changes (when country or city is saved in CountrySelectionPage)
    const handleStorageChange = (e) => {
      if (e.key === 'selected_country' || e.key === 'selected_city') {
        checkCountry();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically in case storage event doesn't fire (same window)
    const interval = setInterval(() => {
      checkCountry();
    }, 1000);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [isLoggedIn, authLoading]);

  const checkCountry = async () => {
    // Wait for auth to finish loading
    if (authLoading) {
      setChecking(true);
      return;
    }

    try {
      // Check if both country and city are selected
      const hasLocation = await countryService.hasSelectedLocation();
      setHasCountry(hasLocation);
    } catch (error) {
      console.error('Error checking location:', error);
      setHasCountry(false);
    } finally {
      setChecking(false);
    }
  };

  // Show loading while checking
  if (checking) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{ textAlign: 'center', color: 'white' }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid rgba(255, 255, 255, 0.3)',
            borderTopColor: 'white',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // If no country is selected, show country selection page
  if (!hasCountry) {
    return <CountrySelectionPage />;
  }

  // If country is selected, show the children (menu, etc.)
  return children;
};

export default CountryGate;

